/* Authentication utility functions for Magni Sign-in/out Application */

/**
 * Simulates a basic authentication check
 * In a real application, this would verify credentials against a backend
 * @param {string} username - Username to check
 * @param {string} password - Password to check
 * @returns {Promise} - Promise resolving to authentication result
 */
const authenticateUser = async (username:string, password:string): Promise<{success:boolean, user?: {username:string, role:string}, error?: string}> => {
  // This is a placeholder for a real authentication system
  // In a production app, this would make an API call to verify credentials
  
  // Simulate API call delay
  return new Promise((resolve) => {
    setTimeout(() => {
      // Simple check for demo purposes only
      // In a real app, NEVER hardcode credentials or use simple string comparison
      if (username === 'admin' && password === 'magni123') {
        resolve({ success: true, user: { username, role: 'admin' } });
      } else if (username === 'manager' && password === 'magni123') {
        resolve({ success: true, user: { username, role: 'manager' } });
      } else {
        resolve({ success: false, error: 'Invalid credentials' });
      }
    }, 300);
  });
};

/**
 * Checks if the current user has admin privileges
 * @returns {boolean} - True if user has admin privileges
 */
const isAdmin = () => {
  try {
    const user = JSON.parse(localStorage.getItem('magniUser')?? '{}');
    return user && user.role === 'admin';
  } catch (e) {
    console.error('Error checking admin status:', e);
    return false;
  }
};

/**
 * Checks if the current user has manager privileges
 * @returns {boolean} - True if user has manager privileges
 */
const isManager = () => {
  try {
    const user = JSON.parse(localStorage.getItem('magniUser')?? '{}');
    return user && (user.role === 'manager' || user.role === 'admin');
  } catch (e) {
    console.error('Error checking manager status:', e);
    return false;
  }
};


/**
 * Logs out the current user
 * @returns {boolean} - Success status
 */
const logoutUser = () => {
  try {
    localStorage.removeItem('magniUser');
    return true;
  } catch (e) {
    console.error('Error logging out user:', e);
    return false;
  }
};

// Export all functions
export {
  authenticateUser,
  isAdmin,
  isManager,
  logoutUser
};